module.exports = __webpack_public_path__ + "img/craneRearRight.aae10c41.svg";